module.exports = __webpack_public_path__ + "img/single_pictures_4.fbcc1424.jpg";